// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2475":"0976b438","7657":"98df0c28","8482":"9b6193a1"}[chunkId] + ".chunk.css";
};